import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';

const navBarStyle = {
    marginBottom: '40px'
}

export default class Navbar extends Component {
    render() {
        return (
            <nav style={navBarStyle} className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container-fluid">

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/backoffice/pontos_interesse"><span>Pontos de Interesse</span></NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/backoffice/aqui_perto"><span>Aqui Perto</span></NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/backoffice/essencias"><span>Essência</span></NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/backoffice/noticias"><span>Notícias</span></NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/backoffice/eventos"><span>Eventos</span></NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/backoffice/restaurantes"><span>Restaurantes</span></NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/backoffice/lojas"><span>Lojas</span></NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/backoffice/alojamentos"><span>Alojamento</span></NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/backoffice/avisos">Avisos à comunidade</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/backoffice/contactos">Contactos do site</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/backoffice/pessoas">Executivo</NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }
}
